import React from 'react';

import Button from '../../../components/ui/Button';

const BulkOperationsToolbar = ({ 
  selectedCount, 
  onClearSelection, 
  onBulkStatusUpdate,
  onBulkYardTransfer,
  onBulkMaintenanceSchedule 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky top-[7.5rem] z-[80] bg-primary/10 border-b border-primary/20 shadow-elevation-1 animate-slide-in">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="flex items-center justify-center w-8 h-8 bg-primary text-primary-foreground rounded-full text-sm font-semibold">
                {selectedCount}
              </div>
              <span className="text-sm font-medium text-foreground">
                {selectedCount === 1 ? 'unit selected' : 'units selected'}
              </span>
            </div>
            <button
              onClick={onClearSelection}
              className="text-sm text-muted-foreground hover:text-foreground transition-hover"
            >
              Clear selection
            </button>
          </div>

          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="RefreshCw"
              iconPosition="left"
              onClick={onBulkStatusUpdate}
            >
              Update Status
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="MapPin"
              iconPosition="left"
              onClick={onBulkYardTransfer}
            >
              Transfer Yards
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Wrench"
              iconPosition="left"
              onClick={onBulkMaintenanceSchedule}
            >
              Schedule Maintenance
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsToolbar;